module.exports = __webpack_public_path__ + "img/流体力学4_4.9f294ab8.jpg";